// extracted by mini-css-extract-plugin
export default {"cards":"cardsGallery_cards__LUKu4"};